import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from 'handlers';
import Loader from 'components/Loader';
import { StepComponent } from 'components/Steps/stepUtils';
import useCurrentFlow from 'hooks/useCurrentFlow';
import FormNavigation from 'components/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import { CheckingAccountResult } from 'enums/FlowNextResults';

import CheckingAccountsList from './components/BankAccountsList';

import styles from './SelectAccount.module.scss';

const SelectAccount = ({ handleNext }: StepComponent) => {
  const { isMissedPaymentFlow } = useCurrentFlow();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { bankAccounts: checkingAccounts } = useSelector((state: RootState) => state.bankAccount)!;
  const { isLoading: isLoadingApplication } = useSelector((state: RootState) => state.applicationData!);

  const handleContinue = () => {
    handleNext(CheckingAccountResult.Continue);
  };

  useEffect(() => {
    if (checkingAccounts.length > 0) {
      setIsLoading(false);

      // Skip checking account list if accounts are less than 2
      if (checkingAccounts.length < 2) {
        handleContinue();
      }
    }
  }, [checkingAccounts]);

  if (isLoading || isLoadingApplication) {
    return (
      <>
        {isMissedPaymentFlow && <FormNavigation showBackLink={false} title="Missed Payment" />}
        <FormContainer>
          <div className={styles.loaderContainer}>
            <Loader color="#795af7" />
          </div>
        </FormContainer>
      </>
    );
  }

  return (
    <>
      {isMissedPaymentFlow && <FormNavigation title="Bank Account" step={3} stepCount={5} />}
      <FormContainer title="Select the account where you deposit your paycheck">
        <CheckingAccountsList onContinue={handleContinue} />
      </FormContainer>
    </>
  );
};

export default SelectAccount;
